module.exports = __webpack_public_path__ + "img/news_1.98c791d0.png";